export default {

  selectedMedia (state) {
    return state.media.filter(function (medium) {
      return medium.selected === true
    })
  },

  mediaByGroup: (state) => (groupName) => {
    return state.media.filter(function (medium) {
      return medium.group.toLowerCase() === groupName.toLowerCase()
    })
  },

  affectedRegions (state, getters) {

    let regions = new Set()

    getters.selectedMedia.forEach(medium => {
      medium.regions.forEach(region => regions.add(region))
    })

    let array = []
    regions.forEach(v => array.push(v))

    return array

  },

  selectedProducts (state) {
    return state.products.filter(function (product) {
      return product.selected === true
    })
  }

}



// WEBPACK FOOTER //
// ./src/store/getters.js